import axios from "axios";
import { md5 } from "./common";

const MIMIR_URL = process.env.REACT_APP_MIMIR_URL + "/api/log";
const MIMIR_SALT = process.env.REACT_APP_MIMIR_SALT;
class Mimir {
    constructor() {
        this.mimirUrl = MIMIR_URL;
        this.salt = MIMIR_SALT;
    }

    async log(event = {}, fallback = null) {
        const currentToken =
            JSON.parse(localStorage.getItem("user-session") || "{}")?.session
                ?.token || "";
        const platform = JSON.parse(localStorage.getItem("platform") || "{}");
        const timestamp = Date.now();
        const freshMimirToken = md5(
            `${currentToken}/${this.salt}/${timestamp}`
        );
        try {
            const data = {
                params_str: [
                    event?.param1,
                    event?.param2,
                    event?.param3,
                    event?.param4,
                ]
                    .filter((param) => param !== null)
                    .join("|"),
                platform_id: platform?.id || "",
                platform: platform?.name || "",
                type: event?.type,
                event: event?.event,
                username: "guest",
                mimir_token: freshMimirToken,
                date_exp: this.date_exp,
                token: currentToken,
                timestamp,
            };

            await axios.post(this.mimirUrl, data, {
                headers: {
                    token: currentToken,
                    "mimir-token": freshMimirToken,
                },
            });
        } catch (e) {
            console.error("Mimir log failed", e);
        } finally {
            if (typeof fallback === "function") {
                fallback();
            }
        }
    }
}

const mimirInstance = new Mimir();
export default mimirInstance;
